export default class Reference {
  public type: string
  public id: number
  public season: number
}
